import { render, staticRenderFns } from "./fileManagement.vue?vue&type=template&id=63d985c0&scoped=true&"
import script from "./fileManagement.vue?vue&type=script&lang=js&"
export * from "./fileManagement.vue?vue&type=script&lang=js&"
import style0 from "./fileManagement.vue?vue&type=style&index=0&id=63d985c0&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d985c0",
  null
  
)

export default component.exports